export default function IconLogoutSystemError(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height * (747 / 441.776) : 747}
      height={height ? height : width ? width * (441.776 / 747) : 441.776}
      viewBox="0 0 747 441.776"
    >
      <g>
        <path
          fill="#2c0313"
          d="M653.342 413.474H568.42a8.737 8.737 0 0 1 0-17.474h84.922a19.593 19.593 0 0 0 19.57-19.57v-28.307a8.737 8.737 0 1 1 17.474 0v28.307a37.086 37.086 0 0 1-37.044 37.044Z"
        />
        <path
          fill="#2c0313"
          d="M681.649 130.463a8.737 8.737 0 0 1-8.737-8.737V93.419a19.593 19.593 0 0 0-19.57-19.57H568.42a8.737 8.737 0 1 1 0-17.474h84.922a37.086 37.086 0 0 1 37.044 37.044v28.307a8.737 8.737 0 0 1-8.737 8.737Z"
        />
        <path
          fill="#2c0313"
          d="M497.84 441.777a22.7 22.7 0 0 1-3.682-.3L324.54 418.113a23 23 0 0 1-19.622-22.9V64.536a22.844 22.844 0 0 1 18.008-22.12L492.54.58a23.341 23.341 0 0 1 5.112-.58 22.889 22.889 0 0 1 22.891 22.8v396.282a22.7 22.7 0 0 1-22.7 22.695Zm-.189-424.308a5.428 5.428 0 0 0-1.155.125L326.881 59.432a5.477 5.477 0 0 0-4.491 5.253v330.623a5.462 5.462 0 0 0 4.622 5.51l169.756 23.385 1.072.1a5.228 5.228 0 0 0 5.228-5.226V22.836a5.377 5.377 0 0 0-2.027-4.173 5.437 5.437 0 0 0-3.39-1.194Z"
        />
        <path
          fill="#2c0313"
          d="M738.261 243.663H582.573a8.737 8.737 0 1 1 0-17.474h134.6l-41.7-41.7a8.737 8.737 0 0 1 12.353-12.358l56.614 56.614a8.737 8.737 0 0 1-6.179 14.918Z"
        />
        <path
          fill="#73042d"
          d="M738.261 243.663H582.573a8.737 8.737 0 1 1 0-17.474h134.6l-41.7-41.7a8.737 8.737 0 0 1 12.353-12.358l56.614 56.614a8.737 8.737 0 0 1-6.179 14.918Z"
        />
        <path
          fill="#2c0313"
          d="M681.649 300.268a8.737 8.737 0 0 1-6.178-14.915l56.615-56.614a8.737 8.737 0 1 1 12.355 12.355l-56.614 56.615a8.709 8.709 0 0 1-6.178 2.559Z"
        />
        <path
          fill="#73042d"
          d="M681.649 300.268a8.737 8.737 0 0 1-6.178-14.915l56.615-56.614a8.737 8.737 0 1 1 12.355 12.355l-56.614 56.615a8.709 8.709 0 0 1-6.178 2.559Z"
        />
        <path
          fill="#2c0313"
          d="M438.678 235.999a15.814 15.814 0 0 1 0-31.627v14.154Z"
        />
        <path
          fill="#2c0313"
          d="M438.679 235.999V204.372a15.814 15.814 0 1 1 0 31.627Z"
        />
      </g>
      <g>
        <path
          fill="#73042d"
          d="M110.4 330.233a110.393 110.393 0 1 1 110.388-110.391A110.518 110.518 0 0 1 110.4 330.233Zm0-100.679 33.23 33.228a6.868 6.868 0 1 0 9.713-9.712l-33.229-33.231 33.229-33.228a6.869 6.869 0 0 0-9.713-9.715l-33.23 33.231-33.235-33.23a6.87 6.87 0 0 0-9.714 9.715l33.23 33.228-33.23 33.231a6.868 6.868 0 0 0 9.714 9.712l33.229-33.228Z"
        />
      </g>
    </svg>
  );
}
